<template>
  <div class="flyingBook">
    <img v-if="type === 1" src="../../assets/images/failed@2x.png" alt="" />
    <img v-if="type === 0" style="width: 50px" src="../../assets/images/loading.gif" alt="" />
    <div v-if="type === 1">登录失败 请稍后重试</div>
    <div v-if="type === 2" style="width: 230px">
      <img style="width: 230px" src="../../assets/images/feishu_200x200@2x.png" alt="" />
      <div style="margin-top: 20px; font-size: 14px; color: #666666">请在外部浏览器打开该页面</div>
      <div style="margin-top: 16px; font-size: 12px; color: #999999">
        点击<span @click="toProcessPage" style="color:rgb(64, 119, 232); cursor: pointer;"> 打开</span> 可在外部浏览器打开该页面
        </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';

import api from '@/api';
import { post } from '@/utils/http';
import { getLogo } from '@/utils/intConfiguration';
// import { pointTools , traceClick} from '@/utils/point';
import {
  setAccount,
  setUserSys,
  setToken,
  // eslint-disable-next-line import/extensions
} from '../login/login-handler.js';
import { getUiFitment } from '@/utils/accessResources';

const { envList } = require('../../../config/dev.proxy');

export default {
  components: {},
  data() {
    return {
      logoUi: getLogo(),
      args: this.getQueryStringSource(),
      type: 2, // 0-加载中 1-失败
      url_res: null,
      url_login_res: null,
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    this.flyingBookLogin();
  },
  methods: {
    flyingBookLogin() {
      // traceClick(
      //   {
      //     event_type: "web_click",
      //     content: {
      //       event_id: "auth_login_feishu",
      //       event_name: "登录 - 飞书登录",
      //     },
      //   },
      //   true
      // );
      post(api.flyingBookLogin, {
        code: this.args.code,
        state: this.args.state,
      }).then((res) => {
        setToken(res);
        this.getLoginAccount(res);
      });
    },
    // 获取用户信息
    getLoginAccount(loginRes) {
      this.initenv();
      // debugger;
      post(api.loginAccount, {}).catch(() => {
        message.error('用户信息查询失败');
        this.type = 1;
      })
        .then((res) => {
          this.url_res = loginRes;
          this.url_login_res = res;
          // 之后缓存菜单需要参数
          setAccount(res, loginRes);
          getUiFitment().finally(()=>{
            if (res.id) {
            this.$store.commit('emptyTab');
            this.type = 2;
            // this.toProcessPage();
            } else {
              this.type = 1;
            }
          })
        });
    },
    // 跳转指定页面
    toProcessPage() {
      try {
        // eslint-disable-next-line camelcase, prefer-destructuring
        const params = this.getQueryStringSource(this.args.path.split('?')[1]);
        // eslint-disable-next-line no-unused-expressions, camelcase
        const url_data = {
          apiKey: params.layoutApiKey,
          id: this.args.id,
        };
        // eslint-disable-next-line no-unused-expressions
        this.args.id ? params.data = encodeURIComponent(JSON.stringify(url_data)) : null;
        // eslint-disable-next-line no-unused-expressions
        this.args.approval ? params.fromObjectLayoutApiKey = 'todoList' : null;
        // eslint-disable-next-line no-unused-expressions
        this.args.taskId ? params.fromObjectTaskId = this.args.taskId : null;
        const firstPath = this.args.path.split('?')[0].charAt(0);

        // window.open(`${window.location.origin}/${this.args.path.split('?')[0]}?${this.args.path.split('?')[1]}`);
        //  http://192.168.220.131:3070/openAgain
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;

        const routeData = this.$router.resolve({
          path: '/middle',
          query: {
            data: encodeURIComponent(JSON.stringify({
              url_res: _this.url_res,
              url_login_res: _this.url_login_res,
              push: {
                path: `${firstPath !== '/' ? '/' : ''}${this.args.path.split('?')[0]}`,
                query: params,
              },
            })),
            // data: encodeURIComponent(JSON.stringify({
            //   url_res: {},
            //   url_login_res: {},
            //   push: {
            //     path: 'xxx',
            //     query: {},
            //   },
            // })),
          },
        });
        window.open(routeData.href, '_blank');
      } catch (error) {
        this.type = 1;
      }
    },
    getQueryStringSource(url) {
      // eslint-disable-next-line no-restricted-globals
      let qs = '';
      if (!url) {
        qs = window.location.search.length > 0 ? window.location.search.substring(1) : '';
      } else {
        qs = url;
      }
      // eslint-disable-next-line prefer-const
      let args = {};
      // eslint-disable-next-line prefer-const
      let items = qs.length ? qs.split('&') : [];
      let item = null;
      let name = null;
      let value = null;
      let i = 0;
      const len = items.length;
      // eslint-disable-next-line no-plusplus
      for (i = 0; i < len; i++) {
        item = items[i].split('=');
        name = decodeURIComponent(item[0]);
        value = decodeURIComponent(item[1]);
        if (name.length) {
          args[name] = value;
        }
      }
      return args;
    },
  },
};
</script>

<style lang="less" scoped>
.flyingBook {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // height: 100%;
  width: 400px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -60%, 0);

  img {
    display: block;

  }

  div {
    // position: absolute;
    text-align: center;
    font-size: 22px;
    margin-top: 16px;
  }
}
</style>
